export const PlusIcon = ({ size, color, strokeWidth }: { size: number; color?: string; strokeWidth?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.31385 14.3631V2.26367M14.3635 8.31336H2.26416"
        stroke={color ?? 'currentColor'}
        strokeWidth={strokeWidth ?? 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
